/* unplugin-vue-components disabled */import script from "./DepositeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositeCard.vue?vue&type=script&setup=true&lang=js"

import "./DepositeCard.vue?vue&type=style&index=0&id=79f233e6&lang=scss"

const __exports__ = script;

export default __exports__